
import {Prop, Component, Vue, Mixins, Watch} from "vue-property-decorator";
import {TakipEntity} from "@/entity/TakipEntity";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";
import Kur from "@/components/inputs/Kur.vue";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import {ParaBirimiEntity} from "@/entity/ParaBirimiEntity";
import DovizKur from "@/components/inputs/DovizKur.vue";
import {tahsilHarciOrani, tahsilHarciToplami} from "@/utils/tahsilHarci";
import {PlanOzeti, hesapAyarCoz, planOzetiHesapla} from "@/utils/taahhutTutarlari";


@Component({
  components: {DovizKur, Kur,Tutar}
})
export default class TaksitAnaBilgiler extends Mixins(ObjectInputMixin) {
  @Prop() takip!: TakipEntity;
  @Prop() genelToplam!: number;
  // TDT-3234: satırlar ve hesap ayarı ayrı prop olarak gelir. `takip.taksitler` form
  // nesnesine sonradan düz atamayla ekleniyor (reaktif değil); getter'lar prop'tan
  // okuyunca her Hesapla/Baştan Başla sonrası yeniden hesaplanır.
  @Prop() taksitler!: any[] | undefined;
  @Prop() taksitHesapAyar!: any;
  @Prop({default:false}) feragatVarMi !:boolean
  doviz_kur:Array<number>=[]
  doviz_kur_kontrol:boolean[] =[]

  tahsilatTurluDoviz:boolean=false

  mounted() {
    this.dovizKurluAlacaklar
  }

  get dovizKurluAlacaklar(){
    let dovizArray :any = []
    dovizArray = this.takip.talepler[0].alacaklar.filter((doviz: any) => doviz.para_birimi_id != 1);

    dovizArray.forEach((doviz: any) => {
     if(doviz.doviz_kur_tarihi==this.dovizTakipSekli.tahsilat){
       this.tahsilatTurluDoviz=true
     }
    })

    return dovizArray;
  }

  changeDovizTutar(index:number){
    if(this.doviz_kur_kontrol[index]){
      this.doviz_kur_kontrol[index]=false
    }
    this.input()
  }

  @Watch("doviz_kur_kontrol")
  changeDovizKur(){
    this.takip.takip_tarihli_kur.forEach((doviz:any,index) => {
      if (this.takip.talepler[0].alacaklar.find((para:any)=>(para.para_birimi_id==doviz.para_birimi_id))){
          if(this.doviz_kur_kontrol[index] && this.doviz_kur[index]){
            this.$http.put(`/api/v1/takip-tarihli-kur/` + doviz.id, {
              takip_id: this.takip.id,
              id: doviz.id,
              tutar: this.doviz_kur[index],
              para_birimi_id: doviz.para_birimi.id,
            });
          }

      }
    })
    this.$emit("load");
    }

  dovizTakipSekli = DovizTakipSekli
  // TDT-3234: tahsil harcının dokuz türü de sayılır (yalnız tür 1 değil); API'deki
  // Tahsil Harcı kolonuyla aynı küme (bkz. src/utils/tahsilHarci.ts).
  get tahsilHarci(): number {
    return tahsilHarciToplami(this.takip);
  }

  // TDT-3234: eskiden sabit %4,55 basılıyordu; %9,10 gibi oranlı dosyada yanlıştı.
  // Öncelik API ile aynı: takibe özel oran → tahsil harcı kaleminin oranı → yasal taban.
  get tahsilHarciOrani(): number {
    return tahsilHarciOrani(this.takip);
  }

  get hesapAyarKaynak(): any {
    return this.taksitHesapAyar !== undefined ? this.taksitHesapAyar : this.takip?.taksit_hesap_ayar;
  }

  get satirKaynak(): any[] | undefined {
    return this.taksitler !== undefined ? this.taksitler : this.takip?.taksitler;
  }

  get hesapAyarVar(): boolean {
    return hesapAyarCoz(this.hesapAyarKaynak) !== null;
  }

  // Satır varsa "Taahhüte Esas Borç" = Σ taksit tutarı; satır yokken eski davranış
  // (genel toplam) korunur. İşleyecek faiz satır yokken kayıtlı özetten gelir (eski
  // davranış: kayıtlı isleyen_faiz) — alttaki liste şeridiyle aynı kaynak.
  get planVar(): boolean {
    return this.hesapAyarVar && Array.isArray(this.satirKaynak) && this.satirKaynak.length > 0;
  }

  // TDT-3234: "İşleyecek Faiz" ve "Taahhüte Esas Borç" evrakla aynı kaynaktan (taksit
  // satırları). Eskiden genelToplam + isleyen_faiz basılıyordu: plan süresince işleyen BSMV
  // dışarıda kalıyor, feragat/gizlenen kalemler de hesaba katılmıyordu.
  get planOzeti(): PlanOzeti {
    return planOzetiHesapla(this.hesapAyarKaynak, this.satirKaynak);
  }
}
